import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export interface E09FileDetails {
  fileId: number;
  fileName: string;
  operatorByFileUploader: string;
  operatorByInboundPpo: string;
  operatorByOutboundPpo: string;
  accountingYear: number;
  accountingQuarter: number;
  fileVersion: number;
  creationDate: string;
  inboundRemovalDate: string | null;
  outboundRemovalDate: string | null;
  fileStatus: string;
  processDate: string | null;
  inboundAcceptanceDate: string | null;
  outboundAcceptanceDate: string | null;
  notifiedDate: string | null;
  downloadDate: string | null;
  validStatus: string | null;
  samplesCount: number | null;
  pendingOn: string;
  loggedUserOperator: string;
  samples: any | null;
}

interface UseE09FileDetailsParams {
  fileId: number | string | undefined;
  enabled?: boolean;
}

/**
 * Hook to fetch E09 file details by ID
 * 
 * @param params Object containing the file ID and enabled flag
 * @returns Query result with the E09 file details
 */
export const useE09FileDetails = ({ fileId, enabled = true }: UseE09FileDetailsParams) => {
  const numericFileId = fileId ? parseInt(String(fileId), 10) : undefined;
  const isValidId = numericFileId !== undefined && !isNaN(numericFileId) && numericFileId > 0;

  return useQuery<E09FileDetails>({
    queryKey: ['e09FileDetails', numericFileId],
    queryFn: async () => {
      if (!isValidId) {
        throw new Error('Invalid file ID');
      }

      const response = await axios.get(`/data-set/e09/${numericFileId}`);
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: enabled && isValidId
  });
}; 